import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import { ApiGet, ApiPut, ApiDelete, ApiPost } from "../../../helpers/API/ApiData";
import { customStyles } from "../tableStyle";
import { TailSpin } from "react-loader-spinner";
import "./locations.scss";
import { toast } from "react-toastify";
import useDebounce from "../../../hooks/useDebounceHook";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { Trash } from "react-feather";
import { Button } from "reactstrap";

import "moment-timezone";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
// import { useNavigate } from "react-router";

export default function Locations() {
  const [getNewsData, setGetNewsData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [count, setCount] = useState(0);
  // const navigate = useNavigate()

  const [loading, setLoading] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue, 900);

  const [filterData, setFilterData] = useState({});

  const [inputValue, setInputValue] = useState({
    name: "",
    maxParkingTime: "",
    dynamicInputs: [{ id: 1, deviceId: "" }],
  });
  const [deleteDataId, setDeleteDataId] = useState([]);
  const [error, setError] = useState({});

  const [isShowLocationModel, setIsShowLocationModel] = useState(false);
  const [isEditLocation, setIsEditLocation] = useState(false);
  const [addUpdateLoader, setAddUpdateLoader] = useState(false);

  const columns = [
    {
      name: "SNo",
      cell: (row, index) => {
        return <p>{(page - 1) * countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: <span>Standorte</span>,
      width: "250px",
      selector: (row) => {
        return <div>{row.name ? row.name : "-"}</div>;
      },
    },
    {
      name: <span>Datum </span>,
      minWidth: "200px",
      selector: (row) => <div className="profileImage">{row.createdAt ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={row.createdAt} /> : "-"}</div>,
    },

    {
      name: "maximale Parkzeit ",
      width: "200px",
      selector: (row) => <div className="profileImage">{row.maxParkingTime ? row.maxParkingTime + " Minuten" : "-"}</div>,
    },
    {
      name: "Geräte",
      width: "400px",
      selector: (row) => <div className="profileImage">
      {row?.devices?.length + " Geräte"}
    </div>,
    },
    {
      name: "Autorisierte Kennzeichen",
      width: "400px",
      selector: (row) => <div className="profileImage">
      {row?.authorizedPlates?.length}
    </div>,
    },

    {
      minWidth: "150px",
      name: "Aktion",
      selector: (row) => (
        <div className="actionColumn">
          <NavLink to={`/location-details?id=${row?._id}`}>
            <Button
              size="sm"
              color="transparent"
              className="btn btn-icon"
              onClick={() => {
                // navigate(`/location-details?id=${row?._id}`);
              }}
            >
              <svg fill="#000000" width="25px" height="25px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z" />
              </svg>
            </Button>
          </NavLink>
        </div>
      ),
    },
  ];

  const handleDeleteNewsInfo = async (row) => {
    setLoading(true);
    let response = false;
    let body = {
      setArray: [],
      deleteArray: [{
        locationId: row?._id
      }]
    }
    await ApiPost(`dahualocation/createLocationDevice`, body)
      .then((res) => {
        toast.success(res?.data?.messages);
        setLoading(false);
        handleChangeCommom("", "", filterData);
        response = true;
      })
      .catch((err) => {
        setLoading(false);
      });
    return response;
  };

  const handleConfirmDelete = (row) => {
    return Swal.fire({
      title: "Bist du sicher?",
      text: "Möchten Sie den Standort wirklich löschen?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ja, löschen",
      cancelButtonText: "Abbrechen",
      customClass: {
        confirmButton: "btn btn-primary mr-10",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
    }).then(async function (result) {
      if (result.value) {
        const res = await handleDeleteNewsInfo(row);
        if (res) {
          Swal.fire({
            icon: "success",
            title: "Gelöscht!",
            text: "Der Standort wurde gelöscht.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else {
          Swal.fire({
            title: "Abgesagt",
            text: "Löschung abgebrochen!!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Abgesagt",
          text: "Löschung abgebrochen!!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        Swal.fire({
          title: "Abgesagt",
          text: "Löschung abgebrochen!!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  };

  useEffect(() => {
    handleChangeCommom("", "", filterData);
  }, [debouncedSearchValue, page, countPerPage]);

  const handleChangeCommom = async (e, key, filter) => {
    setLoading(true);

    try {
      const response = await ApiGet(`dahualocation/getLocationWithDevice?limit=${countPerPage}&page=${page}${debouncedSearchValue ? `&search=${searchValue}` : ""}`);
      setCount(response?.data?.payload?.pagination?.totalCount);
      setGetNewsData(response?.data?.payload?.locations);
      setLoading(false);
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }
  };

  const customNoDataComponent = () => <div style={{ textAlign: "center", padding: "10px 0px", fontSize: "16px" }}>Aktuell sind keine Daten vorhanden.</div>;

  const handleEditLocation = (row) => {
    setIsEditLocation(true);
    setIsShowLocationModel(true);
    setInputValue({
      name: row?.name,
      maxParkingTime: row?.maxParkingTime,
      dynamicInputs: row?.devices,
      id: row?._id,
    });
  };

  const ValidateForm = () => {
    let error = {};
    let isValid = true;

    if (!inputValue?.name || inputValue?.name?.trim() === "") {
      error.name = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }

    if (!inputValue?.maxParkingTime) {
      error.maxParkingTime = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }

    if (!inputValue?.dynamicInputs?.length <=1 && inputValue?.dynamicInputs[0]?.deviceId.trim() === '') {
      error.dynamicInputs = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }

    setError(error);
    return isValid;
  };

  const handleAddNewsClose = () => {
    setIsShowLocationModel(false);
    setAddUpdateLoader(false);
    setInputValue({ name: "", maxParkingTime: "", dynamicInputs: [{ id: 1, deviceId: "" }] });
    setError({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
    setError({ ...error, [name]: "" });
  };

  const handleAddUser = () => {
    if (ValidateForm()) {
      setAddUpdateLoader(true);

      let body = {
        setArray: [{
          locationId: inputValue?.id,
          name: inputValue?.name ? inputValue?.name : "",
          maxParkingTime: inputValue?.maxParkingTime ? inputValue?.maxParkingTime : "",
          deviceIds: inputValue.dynamicInputs
          .filter((input) => input.deviceId.trim() !== "")
          .map((input, index) => {
            if (index === 0 && input?._id) {
              return { _id: input?._id, deviceId: input?.deviceId };
            }
            return { deviceId: input?.deviceId };
          }),
        }],
        deleteArray: deleteDataId,
      };

      ApiPost(`dahualocation/createLocationDevice`, body)
        .then((res) => {
          toast.success(res?.data?.messages);
          handleAddNewsClose();
          handleChangeCommom("", "", filterData);
          setAddUpdateLoader(false);
          setIsEditLocation(false);
          setInputValue({ name: "", maxParkingTime: "", dynamicInputs: [{ id: 1, deviceId: "" }] });
          setDeleteDataId([])
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setAddUpdateLoader(false);
          handleAddNewsClose();
          setIsEditLocation(false);
          setInputValue({ name: "", maxParkingTime: "", dynamicInputs: [{ id: 1, deviceId: "" }] });
          setDeleteDataId([])
        });
    }
  };

  // const handleUpdateLead = () => {
  //   if (ValidateForm()) {
  //     setAddUpdateLoader(true);

  //     let body = {
  //       setArray: {
  //         name: inputValue?.name ? inputValue?.name : "",
  //         maxParkingTime: inputValue?.maxParkingTime ? inputValue?.maxParkingTime : "",
  //         deviceIds: inputValue.dynamicInputs
  //         .filter((input) => input.deviceId.trim() !== "")
  //         .map((input, index) => {
  //           // Add an "_id" only to the first object or modify as per your logic
  //           if (index === 0 && input._id) {
  //             return { _id: input._id, deviceIds: input.deviceId };
  //           }
  //           return { deviceIds: input.deviceId };
  //         }),
  //       },
  //       deleteArray: deleteDataId,
  //     };


  //     ApiPut(`dahualocation/updateDeviceInLocation?id=${inputValue?.id}`, body)
  //       .then((res) => {
  //         toast.success(res?.data?.messages);
  //         handleAddNewsClose();
  //         handleChangeCommom("", "", filterData);
  //         setAddUpdateLoader(false);
  //         setIsEditLocation(false);
  //         setInputValue({
  //           name: "",
  //           maxParkingTime: "",
  //           dynamicInputs: [{ id: 1, deviceId: "" }],
  //         });
  //       })
  //       .catch((err) => {
  //         toast.error(err?.response?.data?.message);
  //         setAddUpdateLoader(false);
  //         setIsEditLocation(false);
  //         handleAddNewsClose();
  //         setInputValue({
  //           name: "",
  //           maxParkingTime: "",
  //           dynamicInputs: [{ id: 1, deviceId: "" }],
  //         });
  //       });
  //   }
  // };

  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="row mb-4 pr-3">
            <div className="col-12 col-lg-4 d-flex align-items-center">
              <h2 className="pl-3 pt-2">Standorte</h2>
            </div>
            <div className="col-lg-8 justify-content-end align-items-center row">
              <div className="col d-flex align-items-center justify-content-end platez" style={{ gap: "10px 20px" }}>
                <div style={{ width: "300px" }}>
                  <input
                    type="search"
                    className={`form-control form-control-lg form-control-solid `}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      setLoading(true);
                    }}
                    name="search"
                    value={searchValue}
                    placeholder="Suche"
                  />
                </div>
              </div>
            </div>
          </div>
          <DataTable
            data={getNewsData}
            columns={columns}
            responsive
            noDataComponent={customNoDataComponent()}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={page}
            progressPending={loading}
            progressComponent={
              <div className="LoadinComponent">
                <TailSpin color="#334D52" height={30} width={30} />
              </div>
            }
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
            fixedHeader
          />
        </div>


      </div>
    </div>
  );
}
